import { LinkProps } from "@amzn/awsui-components-react/polaris/link";
import { infoOpened, infoUpdated } from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";
import { IInfoProps } from "./interfaces";

export const useInfo = () => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.info);

  return {
    info: selector,
    updateInfo: (payload: React.ReactNode) => dispatch(infoUpdated(payload)),
    setOpenInfo: (payload: boolean) => dispatch(infoOpened(payload)),
  };
};

/**
 * Hook for handling side navigation events
 */
export const useOnFollowHandler = (props: IInfoProps) => {
  const { setOpenInfo } = useInfo();
  const { updateInfo } = useInfo();

  return (event: CustomEvent<LinkProps.FollowDetail>) => {
    if (!event.detail.external) {
      event.preventDefault();
      if (props.help) {
        updateInfo(props.help);
      }
      setOpenInfo(true);
    }
  };
};
